// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2UdRf","head":"ProcedureTableInfo_head__3J5Du"};